import React from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import styles from '../../../../../../layout/layoutHeader/components/styles';
import StyledToolTip from '../../../../../common/StyledToolTip';
import EndTripIcon from '../../../../../../layout/icons/EndTripIcon';
import { compose } from 'recompose';

const EndTrip = ({ classes, theme, enable, eventHub }) => {
  const onShowEndTrip = () => {
    if (enable) {
      eventHub.emit('onShowEndTrip');
    }
  };

  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${
        enable ? classes.enabledDangerIcon : classes.disableIcon
      }`}
      onClick={onShowEndTrip}>
      <StyledToolTip title="End Trip">
        <div className="end-trip-icon-wrapper">
          <EndTripIcon color={enable ? theme.error : theme.iconColor} />
        </div>
      </StyledToolTip>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(React.memo(EndTrip));
